import React, {forwardRef} from 'react'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {TwIconButtonNew} from './containers'
import {IconButtonNewProps} from './types'

export const IconButtonNew = forwardRef(
  (
    {
      icon,
      onClick,
      onMouseDown,
      onMouseUp,
      className,
      forcedState,
      disabled,
      error
    }: IconButtonNewProps,
    forwardedRef
  ) => (
    <TwIconButtonNew
      ref={forwardedRef}
      $disabled={disabled}
      $forcedState={forcedState}
      $error={error}
      onClick={disabled ? undefined : onClick}
      onMouseDown={disabled ? undefined : onMouseDown}
      onMouseUp={disabled ? undefined : onMouseUp}
      className={className}
    >
      <IconTabler
        icon={icon}
        viewBox="0 0 24 24"
        customSize={16}
        className="flex-none block"
      />
    </TwIconButtonNew>
  )
)
